module.exports = __webpack_public_path__ + "img/qyhmain.0e49f4cc.jpg";